var map = {
	"./Argentina12.png": "2cc1",
	"./Cuba1.png": "60dc",
	"./Cuba2.png": "b315",
	"./Japan2.png": "1c0d",
	"./Malaysia1.png": "8b4f",
	"./Malaysia2.png": "93ee",
	"./Mexico1.png": "bb3c",
	"./NewZealand2.png": "cfc8",
	"./Peru1.png": "ef45",
	"./Russia1.png": "41a0",
	"./Russia2.png": "505f",
	"./Spain1.png": "e447",
	"./Spain2.png": "6d4f",
	"./cuba.svg": "3415",
	"./japan1.jpg": "f11a",
	"./mexico.png": "f3ce",
	"./newzeland1.png": "64de",
	"./pexel.png": "9a11",
	"./pexel2.jpg": "d383"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "76b8";